var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"more-width"},[_c('h2',{staticClass:"mb-5"},[_vm._v(_vm._s(_vm.title))]),_vm._l((_vm.text),function(row){return _c('p',{key:row},[_vm._v(" "+_vm._s(row)+" ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }